import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
@Injectable({
  providedIn: 'root',
})
export class ItinerariesService {
  private baseUrl = environment.baseUrl
  private resource: string = 'Itinerario'

  constructor(private httpClient: HttpClient) {}

  public createItineraries(
    // model: CreateItinerariesModel,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Proposta/ItemCotacao/create`,
      model,
    )
  }

  public editItineraries(
    model: any,
    // model: EditItinerariesModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Proposta/edit`,
      model,
    )
  }

  public deleteItineraries(
    // model: DeleteItinerariesModel,
    id: number,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Proposta/ItemCotacao/remove/${id}`,
      { id: id },
    )
  }

  public listPagedItineraries(
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedItinerariesByItemPropose(
    id: number,
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Proposta/ItemProposta-paginated/${id}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedItinerariesStopByItemPropose(
    id: number,
    page: number,
    rows: number = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/Proposta/ItemProposta-paginated/parada/${id}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public searchItineraries(
    // model: SearchItinerariesModel,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search`,
      model,
    )
  }

  public listItineraries(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listall`,
    )
  }

  public getItinerariesbyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/${id}`,
    )
  }

  public searchPagedItineraries(
    page: number,
    rows: number = 15,
    // model: SearchItinerariesModel,
    model: any,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
